var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBznavCareIcon = function SvgBznavCareIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 29,
    fill: "none",
    viewBox: "0 0 24 29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5538A",
    d: "M13.17.745a3 3 0 0 0-2.34 0l-9 3.81A3 3 0 0 0 0 7.319v8.846q-.001.239.04.473c1.38 7.839 8.801 11.034 11.207 11.874a2.27 2.27 0 0 0 1.506 0c2.406-.84 9.826-4.035 11.207-11.874q.041-.234.04-.473V7.318a3 3 0 0 0-1.83-2.762z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12 20.454c2.836-1.29 6.188-3.868 6.188-7.735A3.094 3.094 0 0 0 12 12.684a3.094 3.094 0 0 0-6.187.035c0 3.867 3.351 6.446 6.187 7.735",
    clipRule: "evenodd"
  })));
};
export default SvgBznavCareIcon;